export default __webpack_public_path__ + "static/media/2466.22746ece.png";